import { Question, QuestionCreateData } from '@/models/QuestionCreateData';
import { AxiosError } from 'axios';
import { action } from 'typesafe-actions';
import { EvaluationQuestionTypes } from './types';

export const getQuestionRequest = (questionId: number) => action(EvaluationQuestionTypes.GET_QUESTION_REQUEST, questionId);
export const getQuestionSuccess = (data: Question) => action(EvaluationQuestionTypes.GET_QUESTION_SUCCESS, data);
export const getQuestionFailure = (error: AxiosError) => action(EvaluationQuestionTypes.GET_QUESTION_FAILURE, error);
export const getQuestionClear = () => action(EvaluationQuestionTypes.GET_QUESTION_CLEAR);

export const getQuestionsRequest = (entityId: number, entityType: string) =>
    action(EvaluationQuestionTypes.GET_QUESTIONS_REQUEST, { entityId, entityType });
export const getQuestionsSuccess = (data: Question[]) => action(EvaluationQuestionTypes.GET_QUESTIONS_SUCCESS, data);
export const getQuestionsFailure = (error: AxiosError) => action(EvaluationQuestionTypes.GET_QUESTIONS_FAILURE, error);

export const postQuestionRequest = (data: QuestionCreateData) => action(EvaluationQuestionTypes.POST_QUESTION_REQUEST, data);
export const postQuestionSuccess = (data: Question) => action(EvaluationQuestionTypes.POST_QUESTION_SUCCESS, data);
export const postQuestionFailure = (error: AxiosError) => action(EvaluationQuestionTypes.POST_QUESTION_FAILURE, error);

export const putQuestionReorderRequest = (topicId: number, questionId: number, order: number) =>
    action(EvaluationQuestionTypes.PUT_QUESTION_REORDER_REQUEST, { topicId, questionId, order });
export const putQuestionReorderSuccess = () => action(EvaluationQuestionTypes.PUT_QUESTION_REORDER_SUCCESS);
export const putQuestionReorderFailure = (error: AxiosError) => action(EvaluationQuestionTypes.PUT_QUESTION_REORDER_FAILURE, error);

export const postQuestionRenewRequest = (data: QuestionCreateData) => action(EvaluationQuestionTypes.POST_QUESTION_RENEW_REQUEST, data);
export const postQuestionRenewSuccess = (data: Question) => action(EvaluationQuestionTypes.POST_QUESTION_RENEW_SUCCESS, data);
export const postQuestionRenewClear = () => action(EvaluationQuestionTypes.POST_QUESTION_RENEW_CLEAR);

export const putQuestionRequest = (data: Question) => action(EvaluationQuestionTypes.PUT_QUESTION_REQUEST, data);
export const putQuestionSuccess = (data: Question) => action(EvaluationQuestionTypes.PUT_QUESTION_SUCCESS, data);
export const putQuestionFailure = (error: AxiosError) => action(EvaluationQuestionTypes.PUT_QUESTION_FAILURE, error);

export const deleteQuestionRequest = (questionId: number, lessonId: number) =>
    action(EvaluationQuestionTypes.DELETE_QUESTION_REQUEST, { questionId, lessonId });
export const deleteQuestionSuccess = (questionId: number, lessonId: number) =>
    action(EvaluationQuestionTypes.DELETE_QUESTION_SUCCESS, { questionId, lessonId });
export const deleteQuestionFailure = (error: AxiosError) => action(EvaluationQuestionTypes.DELETE_QUESTION_FAILURE, error);
